import React, { memo, useEffect, useRef, useState } from "react";
import styled from "styled-components";
import TextInputField from "../InputFields/TextInputField";
import ImageField, { Content } from "../InputFields/ImageField";
import { MdClear } from "react-icons/md";
import { IconButton } from "@material-ui/core";
import NumberInputField from "../InputFields/NumberInputField";
import SelectField from "../InputFields/SelectField";

interface ProductExtraProps {
  id: number;
  item: any;
  control: any;
  reset: boolean;
  setValue: any;
  onDelete: (id: number) => void;
}

const ProductExtra: React.FC<ProductExtraProps> = ({ id, item, control, reset, setValue, onDelete }) => {
  const refTitle = useRef(item.data[1].value ? item.data[1].value : "");
  const refPrice = useRef(item.data[2].value ? item.data[2].value : "");
  // const refType = useRef(item.data[2].value ? item.data[3].value : "");

  const createEmptyImage = (id: number): Content => {
    return {
      id: id,
      name: item.data[0].name,
      file_name: undefined,
      contentType: undefined,
      image: undefined,
      is_main_image: false,
    };
  };
  const [image, setImage] = useState<Content>(createEmptyImage(id));
  useEffect(() => {
    setImage(createImageState(id, item.data[0].value));
  }, []);

  const createImageState = (id: number, res?: Content): Content => {
    return res
      ? {
          id: id,
          name: item.data[0].name, //TODO
          file_name: res.file_name,
          contentType: res.contentType,
          image: res.image,
          is_main_image: false,
        }
      : createEmptyImage(id);
  };

  const removeElement = () => {
    onDelete(id);
  };

  const renderFields = (data: any) => {
    return (
      <>
        <UpperSection>
          <ImageContainer>
            <ImageField
              content={image}
              control={control}
              reset={reset}
              required={Boolean(item.data[0].required)}
              setValue={setValue}
            />
          </ImageContainer>
          <IconButton aria-label="Премахване" onClick={removeElement}>
            <MdClear size="1.5rem" />
          </IconButton>
        </UpperSection>
        <TextInputField
          key={id + "title"}
          item={{ ...data[1], value: refTitle.current }}
          control={control}
          reset={reset}
          setValue={setValue}
          textRef={refTitle}
        />
        <NumberInputField
          key={id + "price"}
          item={{ ...data[2], value: refPrice.current }}
          control={control}
          reset={reset}
          setValue={setValue}
          numberRef={refPrice}
        />
        <NumberInputField
          key={id + "price-eur"}
          item={data[3]}
          control={control}
          reset={reset}
          setValue={setValue}
        />
        <SelectField key={id + "type"} item={data[4]} control={control} reset={reset} setValue={setValue} />
      </>
    );
  };
  return <ProductExtraContainer>{renderFields(item.data)}</ProductExtraContainer>;
};

const ProductExtraContainer = styled.div`
  display: flex;
  flex-direction: column;
  border: 1px solid #eaeaea;
  padding: 5px;
  box-sizing: content-box;
  border-radius: 5px;
  margin-bottom: 10px;
`;
const UpperSection = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: baseline;
`;

const ImageContainer = styled.div`
  height: 180px;
`;

export default memo(ProductExtra);
